export interface PosValidateUniqueManagerPinRequestDto {
  /**
   * Pos Access Pin
   */
  posAccessPin: string;
  /**
   * Cost Center Id
   */
  costCentreId: number;
  /**
   * Employee Id for who we validate the pin
   * This is `undefined` when user is not created in Backoffice create new employee
   */
  employeeId?: number;
}
